import BankAccountInfo from "./BankAccountInfo";
export default BankAccountInfo;
